<template>
  <!-- 任务完成情况弹框 -->
  <el-dialog
    title="任务完成情况"
    :visible.sync="visible"
    width="650px"
    :before-close="toggle"
    destroy-on-close
    class="task-progress-dialog"
  >
    <template v-if="itemData">
      <el-descriptions :column="1" size="small" colon labelClassName="text-base text-default-color" contentClassName="text-base text-default-color">
        <el-descriptions-item label="用户名称">{{ itemData.userName || '' }}</el-descriptions-item>
        <el-descriptions-item label="农户姓名" v-if="itemData.personName">{{ itemData.personName }}</el-descriptions-item>
      </el-descriptions>
  
      <TaskProgressItem :checkable="false" :item-data="item" v-for="(item, index) in itemData.prizes" :key="index" />
      <!-- <TaskProgressItem :checkable="false" />
      <TaskProgressItem /> -->
    </template>

    <el-empty v-else description="暂无内容" />
  
    <div slot="footer" class="flex justify-center">
      <el-button type="primary" @click="toggle">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TaskProgressItem from './TaskProgressItem.vue'
import { getActivityPrizeUserTaskHistoryApi } from '@/api'
export default {
  name: "TaskProgressDialog",
  components: { TaskProgressItem },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    recordId: {
      type: String
    },
  },
  data() {
    return {
      visible: false,

      itemData: null,
    }
  },
  watch: {
    show: {
      immediate: true,
      async handler(newVal) {
        this.visible = newVal
        if (newVal) {
          await this.loadData()
        } else {
          setTimeout(() => {
            this.itemData = null
          }, 301);
        }
      },
    },
  },
  methods: {
    toggle() {
      this.visible = !this.visible
      this.$emit('update:show', this.visible)
    },

    async loadData() {
      try {
        let res = await getActivityPrizeUserTaskHistoryApi(this.recordId)
        if (res.code === 0) {
          this.itemData = res.data
        }
      } catch(err) {
        console.log(err)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.task-progress-dialog {
  /deep/ .el-dialog__body {
    max-height: 55vh;
    overflow-y: auto;
  }
}
</style>